import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-night-line bg-night-deep px-5 py-12" data-id="element-48" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl text-center" data-id="element-49" data-mp="3gg0za3iktxxn">
        <p className="font-display text-lg font-bold uppercase tracking-wide text-gold" data-id="element-50" data-mp="32o4bgbnxya72">Geografía Bíblica 3D</p>
        <p className="mt-3 text-sm leading-relaxed text-cream-dim" data-id="element-51" data-mp="36oy1baky1z2l">
          Guía visual de Génesis a Apocalipsis. Material digital de estudio, sin vínculo con ninguna denominación.
        </p>
        <nav aria-label="Enlaces legales" className="mt-6" data-id="element-52" data-mp="3991alritibr">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-cream-dim" data-id="element-53" data-mp="36mtqm4mr2tj">
            <li data-id="element-54" data-mp="3lgoocjn8w4p8">
              <a href="#oferta" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-55" data-mp="3qd6pzana3mxc">
                Términos de uso
              </a>
            </li>
            <li data-id="element-56" data-mp="2a19tpmiidoxa">
              <a href="#oferta" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-57" data-mp="2a1jhr4jztm0c">
                Política de privacidad
              </a>
            </li>
            <li data-id="element-58" data-mp="3l9shh1e8ymmw">
              <a href="#oferta" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-59" data-mp="3lbddkvg7mdmv">
                Contacto
              </a>
            </li>
          </ul>
        </nav>
        <p className="mt-8 text-xs text-cream-dim" data-id="element-60" data-mp="3v5n5kc18p9x2">
          © {new Date().getFullYear()} Geografía Bíblica 3D. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}